import React from "react";

import { Link, useLocation, useHistory, useRouteMatch } from "react-router-dom";

const Menu = () => {
  let location = useLocation();

  return (
    <>
      <li className={location.pathname === "/" ? "active" : ""}>
        <Link to="/" title="Dashboard">
          <i className="fa fa-th-large" />
          <span className="nav-label">Página Inicial</span>
        </Link>
      </li>
      <li className={location.pathname.indexOf("/calculosGerados") >= 0 ? "active" : ""}>
        <Link to="/calculosGerados" title="Aplicativo">
          <i className="fa fa-mobile" />
          <span className="nav-label">Aplicativo</span>
          <span class="fa arrow"></span>
        </Link>
        <ul class='nav nav-second-level collapse in'>
            <li>
            <Link to="/calculosGerados" title="Aplicativo">
          <i className="fa fa-calculator" />
          <span className="nav-label">Cálculos Gerados</span>
        </Link>
            </li>
            
          </ul>
      </li>
      <li className={location.pathname.indexOf("/empresa") >= 0 ? "active" : ""}>
        <Link title="Empresa">
          <i className="fa fa-industry" />
          <span className="nav-label">Empresa</span>
          <span class="fa arrow"></span>
        </Link>
        <ul class='nav nav-second-level collapse in'>
            <li>
              <Link to="/empresa" title="Empresa">
                <i className="fa fa-industry" />
                <span className="nav-label">Empresa</span>
              </Link>
            </li>
            <li>
              <Link to="/filial" title="Filial">
                <i className="fa fa-industry" />
                <span className="nav-label">Filial</span>
              </Link>
            </li>
            <li>
              <Link to="/contato" title="Contato">
                <i className="fa fa-address-card" />
                <span className="nav-label">Contato</span>
              </Link>
            </li>
            <li>
              <Link to="/link" title="Links úteis">
                <i className="fa fa-link" />
                <span className="nav-label">Links úteis</span>
              </Link>
            </li>
            <li>
              <Link to="/marco-historico" title="História">
                <i className="fa fa-calendar-o" />
                <span className="nav-label">Marcos históricos</span>
              </Link>
            </li>
            <li>
              <Link to="/novidade" title="Novidades">
                <i class="fa fa-newspaper-o"></i>
                <span className="nav-label">Novidades</span>
                
              </Link>
            </li>
            <li>
              <Link to="/rede-social" title="Redes Sociais">
                <i class="fa fa-facebook"></i>
                <span className="nav-label">Redes Sociais</span>
              </Link>
            </li>
            <li>
              <Link to="/setor" title="Setores">
                <i class="fa fa-sitemap"></i>
                <span className="nav-label">Setor</span>
              </Link>
            </li>
            <li>
              <Link to="/manuais" title="Catalogo">
                <i className="fa fa-file-text-o" />
                <span className="nav-label">Catálogos</span>
              </Link>
            </li>
          </ul>
      </li>
      <li className={location.pathname.indexOf("/produto") >= 0 ? "active" : ""}>
        <Link title="Produtos">
          <i className="fa fa-object-ungroup" />
          <span className="nav-label">Produto</span>
          <span class="fa arrow"></span>
        </Link>
          <ul class='nav nav-second-level collapse in'>
            <li>
              <Link to="/produto" title="Produto">
                <i className="fa fa-object-ungroup" />
                <span className="nav-label">Produto</span>
              </Link>
            </li>
            <li>
              <Link to="/caracteristica" title="caracteristica">
                <i class="fa fa-tags"></i>
                <span className="nav-label">Caracteristicas</span>
              </Link>
            </li>
            <li>
              <Link to="/categoria" title="categoria">
                <i className="fa fa-object-group" />
                <span className="nav-label">Categorias</span>
              </Link>
            </li>
            
          </ul>
      </li>
      <li className={location.pathname.indexOf("/vendedor") >= 0 ? "active" : ""}>
        <Link title="Vendedor">
          <i className="fa fa-user-circle-o" />
          <span className="nav-label">Vendedor</span>
          <span class="fa arrow"></span>
        </Link>
          <ul class='nav nav-second-level collapse in'>
            <li>
              <Link to="/vendedor" title="Vendedor">
                <i className="fa fa-user-circle-o" />
                <span className="nav-label">Vendedor</span>
              </Link>
            </li>
            <li>
              <Link to="/regiao" title="Região">
                <i className="fa fa-map-marker" />
                <span className="nav-label">Região</span>
              </Link>
            </li>
            <li>
              <Link to="/regiao-vendedor" title="VendedorRegiao">
                <i class="fa fa-street-view"></i>
                <span className="nav-label">Vendedor x Região</span>
              </Link>
            </li>
           </ul>
      </li>
      <li className={location.pathname.indexOf("/projeto") >= 0 ? "active" : ""}>
        <Link title="Projeto">
          <i className="fa fa-list-alt" />
          <span className="nav-label">Projeto</span>
          <span class="fa arrow"></span>
        </Link>
        <ul class='nav nav-second-level collapse in'>
            <li>
              <Link to="/tipo-projeto" title="Tipo Projeto">
                <i className="fa fa-list" />
                <span className="nav-label">Tipo de Projeto</span>
              </Link>
            </li>
            <li>
              <Link to="/projeto" title="Projeto">
                <i className="fa fa-list-alt" />
                <span className="nav-label">Projeto</span>
              </Link>
            </li>
          </ul>
      </li>
      
      <li className={location.pathname.indexOf("/usuario") >= 0 ? "active" : ""}>
        <Link to="/usuario" title="Gerenciamento">
          <i className="fa fa-gear" />
          <span className="nav-label">Gerenciamento</span>
          <span class="fa arrow"></span>
        </Link>
        <ul class='nav nav-second-level collapse in'>
            <li>
            <Link to="/usuario" title="Usuário">
          <i className="fa fa-user" />
          <span className="nav-label">Usuário</span>
        </Link>
            </li>
            
          </ul>
      </li>
    </>
  );
};

export default Menu;
